import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import Api, { errorToast } from "utils/api/Api";

export const ButtonUserBookDelete = ({bookId})=>{
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { school } = useParams();
    
    const deleteMutate = useMutation({
        mutationFn:()=>Api.get(`/api/userBook/${bookId}/delete`),
        onSuccess:()=>{
            queryClient.setQueryData(['userbook', bookId], )
            navigate(`/${school}/userbook?list=my`);
        },
        onError:errorToast
    });

    const onDelete = ()=>{
        if(deleteMutate.isPending)return;
        if (!window.confirm("작품을 삭제하시겠습니까?\n(표지와 모든 글이 삭제됩니다.)")) return;
        deleteMutate.mutate();
    }

    return <button className="btn btn_delete" onClick={onDelete}><i className="far fa-trash-alt"></i> 작품삭제</button>;
}